import { Button, Flex, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import getImageSrc from "src/utils/getImageSrc";
import { getAppValue } from "src/utils/environment";
import { H2, BodyText } from "src/atoms/typography";
import FullScreen from "src/atoms/FullScreen";

export default function AppFailure({ onRestart }) {
  const { t } = useTranslation();
  return (
    <FullScreen position="fixed">
      <Flex
        alignItems="center"
        flexDirection="column"
        width="100%"
        height="100%"
      >
        <Flex
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          flex="1 1 auto"
        >
          <Image
            width={["176px", "234px", "264px"]}
            src={getImageSrc(
              getAppValue({
                barkio: "sad-dog.svg",
                bibino: "failure.svg"
              })
            )}
          />
          <H2
            color="highEmphasis"
            mt={["24px", "38px", "45px"]}
            fontSize={["2rem", "2.8rem", "3.2rem"]}
          >
            {t("appFailure.heading")}
          </H2>
          <BodyText
            color="mediumEmphasis"
            mt={["8px", "11px", "13px"]}
            fontSize={["1.4rem", "1.9rem", "2.2rem"]}
          >
            {t("appFailure.text")}
          </BodyText>
        </Flex>

        <Button
          variant="containedPrimary"
          mb={["24px", "32px"]}
          w={["196px", "236px", "256px"]}
          pr={["24px", "40px", "46px"]}
          pl={["24px", "40px", "46px"]}
          pt={["11px", "17px", "19px"]}
          pb={["11px", "17px", "19px"]}
          borderRadius={["18px", "28px", "36px"]}
          fontSize={["1.2rem", "1.7rem", "1.8rem"]}
          onClick={onRestart}
        >
          {t("buttons.connect")}
        </Button>
      </Flex>
    </FullScreen>
  );
}
